export default __webpack_public_path__ + "96727eafaafbef3745816f5d55adcebf.png";